/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import propTypes from 'prop-types';
import { showVotesPercent } from '../../utils/votes';

export default function AssemblyCard({ option, total, badge }) {
  return (
    <p className="mb-0  votes-text d-flex align-items-center ">
      <span className={`badge ${badge} badge-sm mr-2`}>&nbsp;</span>
      {showVotesPercent({ votes: option.votes || [], total })} - {option.description}
    </p>
  );
}

AssemblyCard.propTypes = {
  option: propTypes.object.isRequired,
  total: propTypes.number.isRequired,
  badge: propTypes.string.isRequired,
};
